import { Container } from '@hover/blueprint';
import React from 'react';
import LogoSlider from './LogoSlider';
import { HeaderDescription } from '..';

const TrustedSection: React.FC = () => (
  <Container
    maxW="1200px"
    mt={1000}
    overflow="hidden"
    flexDir="column"
    alignItems="center"
  >
    <HeaderDescription
      px={{ base: 0, tablet: '56px' }}
      heading="Chosen by the names you trust in home protection and restoration"
      body="HOVER is trusted by thousands of names from home improvement
          contractors, to materials manufacturers, distributors, and insurers."
      maxW="5xl"
      overflow="hidden"
      mb="52px"
    />
    <LogoSlider />
  </Container>
);

export default TrustedSection;
